export const VERSION_WEB = 'version 1.5.6 25-08-2026';